import React from 'react'
import Icon from '../../icon/icon.component'
import * as Styles from './toggler.styles'

type Props = {
  collapsed: boolean
  onToggle: Function
}

const Toggler: React.FC<any> = (props: Props) => {
  const onClick = (): void => props.onToggle(!props.collapsed)

  return (
    <Styles.Toggler onClick={onClick}>
      <Icon
        icon={props.collapsed ? 'chevron-right' : 'chevron-left'}
      />
    </Styles.Toggler>
  )
}

export default Toggler
